import HttpService from '@/shared/services/HttpService';
import {DetailInfo, Transaction} from './types';

class ProfileService {
    private http = new HttpService();
    public async getTransactions(): Promise<Transaction[]> {
        return await this.http.get('/profile/transactions');
    }
    public async fakeGetTransactions(): Promise<Transaction[]> {
        return new Promise((resolve) => {
            resolve([
                {
                    date: "2019-01-12",
                    info: 'Fund add in wallet account',
                    amount: 100,
                    balance: 400,
                }, {
                    date: "2019-01-12",
                    info: 'Fund add in wallet account 2',
                    amount: 200,
                    balance: 300,
                }, {
                    date: "2019-01-12",
                    info: 'Fund add in wallet account 4',
                    amount: 300,
                    balance: 1000,
                },
            ]);
        });
    }
    public async getUserInfo(): Promise<DetailInfo> {
        return await this.http.get('/profile/info');
    }
    public async fakeGetUserInfo(): Promise<DetailInfo> {
        return new Promise((resolve) => {
            resolve({
                phone: '',
                matchesPlayed: 100,
                contestsPlayed: 10,
                contestsWon: 12,
                deposited: 15,
                winnings: 15,
                bonus: 100,
                balance: 500,
            });
        });
    }
}

export default new ProfileService();
